import { render } from "./project_basic_info.vue?vue&type=template&id=3772f20e&scoped=true"
import script from "./project_basic_info.vue?vue&type=script&lang=js"
export * from "./project_basic_info.vue?vue&type=script&lang=js"

import "./project_basic_info.vue?vue&type=style&index=0&id=3772f20e&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3772f20e"]])

export default __exports__